import React from 'react';
import PropTypes from 'prop-types';

import { ButtonBase, Typography } from '@material-ui/core';

import { Container } from './styles';

const BigButton = ({ children, icon, selected, ...rest }) => {
  return (
    <Container selected={selected}>
      <ButtonBase {...rest}>
        <div id="icon">{icon}</div>

        <div id="text">
          <Typography>{children}</Typography>
        </div>
      </ButtonBase>
    </Container>
  );
};

BigButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  icon: PropTypes.node.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default BigButton;
